module.exports = __webpack_public_path__ + "static/media/column-chart-new.74b841d9.png";